module.exports = __webpack_public_path__ + "img/oldEstate_shop.27a43e07.png";